var lists = require('../../shared/lists');
var utils = require('../../shared/utils');

var transformLinkItem = function(linkItem){
	return {
		Display: linkItem.Title,
		URL: linkItem.URL,
		SortOrder: linkItem.SortOrder,
		LinkTarget: linkItem.OpenInNewTab ? "_blank" : "_self"
	}
}

var groupLinks = function(listItems = []) {
	// Use an object map for 'linkGroups' to avoid array lookups
	var linkGroups = {};
	listItems.forEach(item => {
		if(!linkGroups[item.Group]) {
			linkGroups[item.Group] = { GroupName: item.Group, links: [] }
		} 
		linkGroups[item.Group].links.push(transformLinkItem(item));
	})
	// Turn the object into an array, sort the object keys before mapping to avoid custom sort function
	return Object.keys(linkGroups).sort().map(key => linkGroups[key]);
}


// Public
exports.getLinks = function(){
	var odata = "$select=Title,URL,SortOrder,Group,OpenInNewTab&$orderby=SortOrder,Title";
	return lists.LinksMyAccount.getItems(odata).then(groupLinks);
}

exports.getName = function(){
	return utils.getUserProfile().then(p => p.FirstName || p.PreferredName || p.DisplayName || p.UserName);
}



// WEBPACK FOOTER //
// ./src/scripts/components/myAccount/data.js